export enum BottomCandlesType {
  SIZE = 'size',
  ABSOLUTE_DELTA = 'absolute_delta',
  FILTERED_DELTA = 'filtered_delta',
}
